"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mapbox_gl_1 = __importDefault(require("mapbox-gl"));
mapbox_gl_1.default.accessToken = 'pk.eyJ1Ijoiam9yZGFuY2hpdHR5IiwiYSI6ImNsdGhnZ2JwcjAzeHMya256ZWtuaDl3aDEifQ.QjyLAZpxdiu8Zw-QrCp-CA';
const container = document.getElementById('map');
let map = null; // define map variable outside if statement
if (container) {
    const lat = container.getAttribute('data-lat');
    const long = container.getAttribute('data-long');
    const color = container.getAttribute('data-color');
    let hex;
    switch (color) {
        case 'private':
            hex = '#49796b';
            break;
        case 'assset':
            hex = '#3879b2';
            break;
        case 'lorica':
            hex = '#b04f7d';
            break;
        case 'gold':
            hex = '#EC9F22';
            break;
        default:
            hex = '#f0645a';
    }
    map = new mapbox_gl_1.default.Map({
        container: 'map',
        // style: 'mapbox://styles/jordanchitty/cltowopft00fr01pc3dnt1s5m', //premier
        style: 'mapbox://styles/jordanchitty/cltpvodyn00wi01nr1w0b081t',
        center: [long, lat],
        zoom: 15
    });
    const marker = new mapbox_gl_1.default.Marker({
        color: hex
    }).setLngLat([long, lat]).addTo(map);
    map.scrollZoom.disable();
    map.doubleClickZoom.disable();
    map.boxZoom.disable();
    map.keyboard.disable();
    map.touchZoomRotate.disable();
    map.addControl(new mapbox_gl_1.default.NavigationControl(), "top-right");
}
